<template>
  <div class="row" v-if="hasCustomer">
    <div class="col-xs-12">
      <small>
        <strong>UC:</strong> {{ customer.uc }}
        <span class="customer-content"><strong>Nome:</strong> {{ customer.holder }} </span>
        <span class="customer-content"><strong>CPF:</strong> {{ customer.cpf }} </span>
        <br>
        <span><strong>Endereço:</strong> {{ customer.address.street }}</span>
        <span class="customer-content"><strong>Número:</strong> {{ customer.address.number }}</span>
        <span class="customer-content"><strong>Bairro:</strong> {{ customer.address.neighborhood }}</span>
        <span class="customer-content"><strong>Complemento:</strong> {{ customer.address.complement }}</span>
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'survey-customer-content',
  props: {
    customer: {
      required: true
    }
  },

  computed: {
    hasCustomer () {
      return this.customer.hasOwnProperty('_id')
    },
    phoneNumbers () {
      return this.customer.phones.length > 0 ? this.customer.phones.join(' / ') : ' - '
    }
  }
}
</script>

<style scoped>
.customer-content {
  margin-left: 5px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyCustomerContent.vue